import { knownAppWebUrl } from "./app-schemes";
export const LAUNCH_PLATFORMS = [
    "android",
    "tizen",
    "webos",
    "ios",
    "web",
];
export const LAUNCH_PLATFORM_LABELS = {
    android: "Android",
    tizen: "Samsung Tizen",
    webos: "LG webOS",
    ios: "Apple iOS / tvOS",
    web: "Web",
};
const NONE = { kind: "none", id: null, source: null };
function clean(v) {
    if (typeof v !== "string")
        return undefined;
    const t = v.trim();
    return t.length ? t : undefined;
}
export function isWebUrl(v) {
    const t = clean(v);
    return !!t && /^https?:\/\//i.test(t);
}
function nativeField(platform) {
    switch (platform) {
        case "android":
            return "androidSlug";
        case "tizen":
            return "tizenId";
        case "webos":
            return "webosId";
        case "ios":
            return "iosScheme";
        default:
            return null;
    }
}
export function resolveLaunchTarget(app, platform) {
    if (!app || typeof app !== "object")
        return NONE;
    const field = nativeField(platform);
    const native = field ? clean(app[field]) : undefined;
    if (native)
        return { kind: "native", id: native, source: field };
    const web = clean(app.webUrl);
    if (web && isWebUrl(web))
        return { kind: "web", id: web, source: "webUrl" };
    if (platform === "web") {
        const known = knownAppWebUrl(clean(app.name));
        if (known && isWebUrl(known))
            return { kind: "web", id: known, source: "knownApp" };
    }
    return NONE;
}
export function launchIdFor(app, platform) {
    var _a;
    const t = resolveLaunchTarget(app, platform);
    return t.kind === "native" ? ((_a = t.id) !== null && _a !== void 0 ? _a : undefined) : undefined;
}
export function resolveApps(apps, platform, opts = {}) {
    const list = Array.isArray(apps) ? apps : [];
    const out = list.map((app) => {
        const launch = resolveLaunchTarget(app, platform);
        return { ...app, launch, available: launch.kind !== "none" };
    });
    return opts.hideUnavailable ? out.filter((a) => a.available) : out;
}
export function launchableApps(apps, platform) {
    return resolveApps(apps, platform, { hideUnavailable: platform !== "web" });
}
export function appCoverage(app) {
    const out = [];
    for (const p of LAUNCH_PLATFORMS) {
        if (p === "web") {
            if (isWebUrl(app === null || app === void 0 ? void 0 : app.webUrl))
                out.push(p);
            continue;
        }
        const field = nativeField(p);
        if (field && clean(app === null || app === void 0 ? void 0 : app[field]))
            out.push(p);
    }
    return out;
}
export function appGaps(app) {
    return LAUNCH_PLATFORMS.filter((p) => resolveLaunchTarget(app, p).kind === "none");
}
export function catalogueCoverage(apps) {
    const byPlatform = {
        android: 0,
        tizen: 0,
        webos: 0,
        ios: 0,
        web: 0,
    };
    const list = Array.isArray(apps) ? apps : [];
    let orphans = 0;
    for (const app of list) {
        const cov = appCoverage(app);
        for (const p of cov)
            byPlatform[p] += 1;
        if (!cov.length)
            orphans += 1;
    }
    return { byPlatform, orphans, total: list.length };
}
